import React from 'react'
import { IPermissionProps } from '@/types/shared'
import SubHeaders from '@/components/Headers/SubHeaders'
import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import AddIcons from '@/icons/AddIcons'
import { useJobList } from './use-job-list'

const List: React.FC<IPermissionProps> = () => {
    const {
        jobs,
        pagination,
        stateComponent,
        params,
        control,
        setFilter,
        searchInputProps,
        columns,
        actions,
        filterItems,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
        handleCreateNew,
        handleManageCategories,
        t,
    } = useJobList()

    return (
        <div className="space-y-2">
            <SubHeaders
                actions={[
                    {
                        label: t('create'),
                        onClick: handleCreateNew,
                        variant: 'contained',
                        icon: <AddIcons />,
                    },
                    {
                        label: t('job-category-information'),
                        onClick: handleManageCategories,
                        variant: 'outlined',
                    },
                ]}
                breadcrumbs={[
                    {
                        path: '/jobs',
                        title: t('job-list'),
                    },
                ]}
            />

            {/* Filters */}
            <Paper>
                <FilterBar
                    control={control}
                    setFilter={setFilter}
                    items={filterItems}
                    hideSearch
                />
            </Paper>

            {/* Data table */}
            <Paper>
                {stateComponent || (
                    <DataTableCustomized
                        columns={columns}
                        rows={jobs}
                        rowKey={(row) => String(row.job_id)}
                        resizable
                        size="small"
                        autoWidth
                        actions={actions}
                        toolbar={{
                            search: {
                                ...searchInputProps,
                                placeholder: t('search'),
                            },
                            settings: {
                                show: true,
                                storageKey: 'job-list',
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                    />
                )}
            </Paper>
        </div>
    )
}

export default List
